import React, { useContext } from 'react'
import { getStepByStepId } from 'app/React/Helpers/StepHelper'
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

function TipLine(props) {
  const { currentVariant } = useContext(ConfiguratorContext)

  if (props.step === null) return null

  const steps = currentVariant.steps ?? {}
  const step = getStepByStepId(steps, props.step)

  if (step === null) return null

  const variant_tip = currentVariant['step' + props.step + '_tip'] ?? ''
  const tip = variant_tip?.length > 0 ? variant_tip : step.tip

  if (typeof tip !== 'string' || tip.length < 1) return null

  return (
    <div className='tip'>
      <p>{tip}</p>
    </div>
  )
}

TipLine.defualtProps = {
  step: null
}

export default TipLine
